import { filter, firstValueFrom, map, Observable } from 'rxjs';
import { TreeValidationResult } from '@angular/forms/signals';
import { CallState, ErrorState, LoadingState } from './models';

// Helper function to extract error, if there is one.
export function getError(callState: CallState): string | null {
  if ((callState as ErrorState).errorMsg !== undefined) {
    return (callState as ErrorState).errorMsg;
  }
  return null;
}

export function callStateFinished(
  error: string,
): (source: Observable<CallState>) => Observable<TreeValidationResult> {
  return (source) =>
    source.pipe(
      filter(
        (callState) =>
          callState !== LoadingState.INIT && callState !== LoadingState.LOADING,
      ),
      map((callState) => {
        if (callState === LoadingState.LOADED) {
          return null;
        }

        return { kind: 'serverError', message: error };
      }),
    );
}

export function handleFormSubmissionCallState(
  callState: Observable<CallState>,
  error: string,
): Promise<TreeValidationResult> {
  return firstValueFrom(callState.pipe(callStateFinished(error)));
}
